import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IIntake } from "../../utils/types/models";

export default createEntityReducer<IIntake>(Endpoint.Intakes);
